import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import Modal from "antd/lib/modal";
import { Button } from "antd";

const VideoPreview = ({
  videoPreview,
  setIsModalOpen,
  isModalOpen,
  isValidUrlFlag,
}) => {
  const vidRef = useRef(null);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [visible, setVisible] = useState(false);
  const [isModalReadMore, setIsModalReadMore] = useState({
    value: false,
    id: null,
  });
  const [videoError, setVideoError] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
    vidRef.current.pause();
    vidRef.current.currentTime = 0;
  };

  const handleVideoError = () => {
    setVideoError(true);
  };

  return (
    <Modal
      title={
        <div className="text_heading-Slab font-size16 font-weight500">
          Video Preview
        </div>
      }
      footer={null}
      visible={isModalOpen}
      onOk={handleCancel}
      onCancel={handleCancel}
      width={675}
      style={{ top: "2rem", backgroundColor: "transparent" }}
      className={`postCard_dtails ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
    >
      {!isValidUrlFlag && !videoError ? (
        <video
          onError={handleVideoError}
          ref={vidRef}
          width="100%"
          height="400"
          controls
          autoPlay
        >
          <source src={videoPreview} type="video/mp4" />
        </video>
      ) : (
        <>
          <video
            onError={handleVideoError}
            ref={vidRef}
            width="100%"
            height="400"
            controls
            autoPlay
          >
            <source src={videoPreview} type="video/mp4" />
          </video>
          <div className="video-player-expired-popup">
            <i
              class="fa fa-info-circle"
              style={{ fontSize: "2rem", color: "#fff" }}
            ></i>
            <p className="video-player-expired-popup-text">
              This video is not compatible with this platform. Please download
              it to watch.
            </p>
            <a
              className={
                videoPreview && videoPreview?.trim() && videoPreview !== "NA"
                  ? ""
                  : "pointer-events1 cursor-default"
              }
              href={
                videoPreview && videoPreview?.trim() && videoPreview !== "NA"
                  ? videoPreview
                  : ""
              }
              target="_blank"
              rel="noreferrer"
            >
              <Button
                className={`ant-btn-primary_blue mr-15 `}
                style={{ padding: "1.3rem 1.5rem", height: "auto" }}
                type="primary"
              >
                {" "}
                Download
              </Button>
            </a>
          </div>
        </>
      )}
    </Modal>
  );
};

export default React.memo(VideoPreview, isEqual);
